import React, { useEffect } from 'react';
import EventList from './components/EventList';
import { Container, CssBaseline, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import logo from './images/logo.png';
import './App.css';

// This will be replaced during build time with the actual timestamp
// Build 2 - Testing cache busting
const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || Date.now();

function App() {
  useEffect(() => {
    // Only check build time in production
    if (process.env.NODE_ENV === 'production') {
      const lastBuildTime = localStorage.getItem('lastBuildTime');
      console.log('Current build time:', BUILD_TIME);
      console.log('Last build time:', lastBuildTime);
      if (lastBuildTime && lastBuildTime !== BUILD_TIME.toString()) {
        console.log('Build time mismatch - forcing reload');
        // Clear all cached data
        localStorage.clear();
        // Force reload
        window.location.reload(true);
      }
      // Store current build time
      localStorage.setItem('lastBuildTime', BUILD_TIME.toString());
    }
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="App">
        <CssBaseline />
        <Container>
          <div className="slim-header">
            <div className="slim-header__left">
              <img
                src={logo}
                alt="Events Bridge Logo"
                className="slim-header__logo"
              />
            </div>
            <div className="slim-header__tagline">
              Find events by date, location, or style — use the filters below,
              then ✕ to clear
            </div>
          </div>
          <EventList />
        </Container>
      </div>
    </LocalizationProvider>
  );
}

export default App;
